exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-menu__submenu{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-bottom:.5rem}.c-submenu__toggle,.c-submenu__toggle.is-active{color:tomato;background-color:transparent}.menu-toggler:not(:checked)~.c-submenu__toggle:after{content:\"\\25BA\"}.menu-toggler:checked~.c-submenu__toggle:after{content:\"\\25BC\"}", ""]);

// exports
